/* &Pita reseñas — motor compartido (producto, marca y badge).
   Lee configuración de data-* en los contenedores [data-pita][data-pita-mode].
   Solo lectura: pide al endpoint mktGetReviews y pinta. Caché en window.__pitaReviews. */
(function () {
  if (window.__pitaReviewsBooted) return;
  window.__pitaReviewsBooted = true;

  var DEFAULT_EP = 'https://us-central1-apiypita.cloudfunctions.net/mktGetReviews';
  var cache = (window.__pitaReviews = window.__pitaReviews || {});

  // Datos de ejemplo, solo para previsualizar el diseño cuando un producto aún no tiene reseñas.
  var SAMPLE_PRODUCT = {
    summary: { count: 12, average: 4.8, distribution: { '5': 10, '4': 1, '3': 1, '2': 0, '1': 0 } },
    reviews: [
      { nombre: 'Ana G.', rating: 5, titulo: 'Mi nuevo ritual', mensaje: 'Un chorrito en el latte y sabe a cafetería. Rinde muchísimo y el sabor es natural, nada artificial. Ya no tomo mi café sin él.', verificada: true, respuestaTienda: '¡Gracias Ana! Nos encanta que sea parte de tus mañanas.', fecha: '2026-07-18T20:00:00.000Z' },
      { nombre: 'Diego M.', rating: 4, titulo: '', mensaje: 'Muy rico, solo quisiera que la tapa fuera dosificadora.', verificada: true, fecha: '2026-07-12T20:00:00.000Z' },
      { nombre: 'Regina P.', rating: 5, titulo: 'Delicioso', mensaje: 'En agua fría es otra cosa. Mis visitas siempre preguntan qué les di.', fecha: '2026-07-01T20:00:00.000Z' }
    ]
  };

  function getReviews(ep, params) {
    var key = (params.scope === 'brand' ? 'brand' : ('h:' + (params.handle || ''))) + '|' + (params.limit || 50) + '|' + ep;
    if (cache[key]) return cache[key];
    var qs = params.scope === 'brand' ? 'scope=brand' : ('handle=' + encodeURIComponent(params.handle || ''));
    qs += '&limit=' + (params.limit || 50);
    var p = fetch(ep + '?' + qs, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    cache[key] = p;
    return p;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function round1(v) { return (Math.round((v || 0) * 10) / 10).toFixed(1); }
  function pctFrom(v) { return Math.max(0, Math.min(100, ((v || 0) / 5) * 100)); }
  function starsHTML(pct) {
    return '<span class="pr-stars" aria-hidden="true"><span class="pr-stars__on" style="width:' + pct + '%"></span></span>';
  }
  function fmtDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'short' });
    } catch (e) { return ''; }
  }
  function initials(name) {
    var p = String(name || '').trim().split(/\s+/);
    var a = (p[0] || '')[0] || '';
    var b = (p.length > 1 ? (p[p.length - 1][0] || '') : '');
    return (a + b).toUpperCase() || '★';
  }
  function clampText(msg, clamp) {
    var text = String(msg || '');
    if (!clamp || text.length <= clamp) return { html: esc(text), more: false };
    var cut = text.slice(0, clamp);
    var sp = cut.lastIndexOf(' ');
    if (sp > clamp * 0.6) cut = cut.slice(0, sp);
    return { clip: esc(cut) + '…', full: esc(text), more: true };
  }
  function avatarHTML(r) {
    if (r.logoUrl) return '<span class="pr-ava pr-ava--img"><img src="' + esc(r.logoUrl) + '" alt="' + esc(r.nombre) + '" loading="lazy"></span>';
    return '<span class="pr-ava">' + esc(initials(r.nombre)) + '</span>';
  }
  function whoHTML(r) {
    var nm = r.url
      ? '<a class="pr-name" href="' + esc(r.url) + '" target="_blank" rel="noopener">' + esc(r.nombre) + '</a>'
      : '<span class="pr-name">' + esc(r.nombre) + '</span>';
    var city = r.ciudad ? '<span class="pr-city">' + esc(r.ciudad) + '</span>' : '';
    return '<span class="pr-who">' + nm + city + '</span>';
  }
  function photosHTML(fotos, name) {
    if (!fotos || !fotos.length) return '';
    var h = '<div class="pr-photos">';
    for (var i = 0; i < Math.min(fotos.length, 4); i++) {
      h += '<button type="button" class="pr-photo" data-src="' + esc(fotos[i]) + '" aria-label="Ver foto"><img src="' + esc(fotos[i]) + '" alt="Foto de ' + esc(name) + '" loading="lazy"></button>';
    }
    return h + '</div>';
  }

  /* ---- lightbox compartido ---- */
  var lb;
  function openLightbox(src, alt) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'pr-lightbox';
      lb.innerHTML = '<button type="button" class="pr-lightbox__close" aria-label="Cerrar">×</button><img alt="">';
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('pr-lightbox__close')) closeLightbox();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
      document.body.appendChild(lb);
    }
    var img = lb.querySelector('img');
    img.src = src; img.alt = alt || '';
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (lb) lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ---- modal de reseña completa (para las largas del destacado) ---- */
  var rmodal;
  function openReviewModal(r) {
    if (!r) return;
    if (!rmodal) {
      rmodal = document.createElement('div');
      rmodal.className = 'pr-modal';
      rmodal.innerHTML = '<div class="pr-modal__card" role="dialog" aria-modal="true"><button type="button" class="pr-modal__close" aria-label="Cerrar">×</button><div class="pr-modal__body"></div></div>';
      rmodal.addEventListener('click', function (e) {
        if (e.target === rmodal || e.target.classList.contains('pr-modal__close')) { closeReviewModal(); return; }
        var ph = e.target.closest('.pr-photo');
        if (ph) openLightbox(ph.getAttribute('data-src'), 'Foto');
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReviewModal(); });
      document.body.appendChild(rmodal);
    }
    rmodal.querySelector('.pr-modal__body').innerHTML =
      starsHTML(pctFrom(r.rating)) +
      (r.titulo ? '<p class="pr-modal__title">' + esc(r.titulo) + '</p>' : '') +
      '<blockquote class="pr-modal__q">' + esc(r.mensaje) + '</blockquote>' +
      photosHTML(r.fotos, r.nombre) +
      '<div class="pr-modal__by">' + avatarHTML(r) + whoHTML(r) + '</div>';
    rmodal.querySelector('.pr-modal__card').scrollTop = 0;
    rmodal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeReviewModal() {
    if (rmodal) rmodal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function hideSection(root) {
    var sec = root.closest('[data-pita-section]');
    if (sec) sec.style.display = 'none';
  }

  /* ---- modo producto ---- */
  function renderProduct(root, data, cfg) {
    var previewing = false;
    if (cfg.preview && (!data || !data.summary || !data.summary.count)) { data = SAMPLE_PRODUCT; previewing = true; }
    var s = (data && data.summary) || null;
    var reviews = (data && data.reviews) || [];
    if (!s || !s.count) {
      if (cfg.emptyHide) { hideSection(root); return; }
      root.innerHTML = '<p class="pr-empty">Aún no hay reseñas de este producto.</p>';
      return;
    }
    var previewNote = previewing ? '<p class="pr-preview-note">Vista previa · datos de ejemplo (apaga “Mostrar ejemplos” al publicar)</p>' : '';
    var dist = s.distribution || {};
    var maxd = Math.max(1, dist['5'] || 0, dist['4'] || 0, dist['3'] || 0, dist['2'] || 0, dist['1'] || 0);
    var distHTML = '';
    [5, 4, 3, 2, 1].forEach(function (n) {
      var c = dist[String(n)] || 0;
      distHTML += '<div class="pr-dist__row"><span class="pr-dist__n">' + n + '★</span><span class="pr-dist__bar"><span style="width:' + ((c / maxd) * 100) + '%"></span></span><span class="pr-dist__c">' + c + '</span></div>';
    });
    var summaryHTML =
      '<div class="pr-summary">' +
        '<div class="pr-summary__score">' +
          '<span class="pr-summary__avg">' + round1(s.average) + '</span>' +
          starsHTML(pctFrom(s.average)) +
          '<span class="pr-summary__count">' + s.count + ' reseña' + (s.count === 1 ? '' : 's') + '</span>' +
        '</div>' +
        '<div class="pr-dist">' + distHTML + '</div>' +
      '</div>';
    var filtersHTML = cfg.filters
      ? '<div class="pr-filters">' +
          '<button type="button" class="pr-filter is-active" data-f="recientes">Recientes</button>' +
          '<button type="button" class="pr-filter" data-f="mejor">Mejor calificadas</button>' +
          '<button type="button" class="pr-filter" data-f="foto">Con foto</button>' +
        '</div>'
      : '';
    root.innerHTML = previewNote + summaryHTML + filtersHTML +
      '<div class="pr-list" data-pr-list></div>' +
      '<div class="pr-more-wrap"><button type="button" class="pr-more" data-pr-more hidden>Ver más reseñas</button></div>';

    var listEl = root.querySelector('[data-pr-list]');
    var moreBtn = root.querySelector('[data-pr-more]');
    var pageSize = cfg.pageSize;
    var current = reviews.slice();
    var shown = 0;

    function cardHTML(r) {
      var ct = clampText(r.mensaje, cfg.clamp);
      var title = r.titulo ? '<p class="pr-card__title">' + esc(r.titulo) + '</p>' : '';
      var msg = '<p class="pr-card__msg' + (ct.more ? ' is-clamped' : '') + '">' + (ct.more ? ct.clip : ct.html) + '</p>';
      var more = ct.more ? '<button type="button" class="pr-readmore" data-full="' + ct.full + '">leer más</button>' : '';
      var reply = r.respuestaTienda ? '<div class="pr-card__reply"><span class="pr-card__reply-b">Respuesta de la tienda</span>' + esc(r.respuestaTienda) + '</div>' : '';
      var verif = r.verificada ? '<span class="pr-verif">✓ Compra verificada</span>' : '';
      var date = r.fecha ? '<span class="pr-card__date">' + esc(fmtDate(r.fecha)) + '</span>' : '';
      return '<article class="pr-card">' +
          '<div class="pr-card__top">' + starsHTML(pctFrom(r.rating)) + date + '</div>' +
          title + msg + more + photosHTML(r.fotos, r.nombre) + reply +
          '<div class="pr-card__by">' + avatarHTML(r) + whoHTML(r) + verif + '</div>' +
        '</article>';
    }
    function renderMore() {
      if (!current.length) { listEl.innerHTML = '<p class="pr-empty">Sin reseñas con este filtro.</p>'; moreBtn.hidden = true; return; }
      var slice = current.slice(shown, shown + pageSize);
      slice.forEach(function (r) { listEl.insertAdjacentHTML('beforeend', cardHTML(r)); });
      shown += slice.length;
      moreBtn.hidden = shown >= current.length;
    }
    function applyFilter(f) {
      var arr = reviews.slice();
      if (f === 'mejor') arr.sort(function (a, b) { return (b.rating - a.rating) || (new Date(b.fecha || 0) - new Date(a.fecha || 0)); });
      else if (f === 'foto') arr = arr.filter(function (r) { return r.fotos && r.fotos.length; });
      current = arr; shown = 0; listEl.innerHTML = '';
      renderMore();
    }
    renderMore();

    moreBtn.addEventListener('click', renderMore);
    if (cfg.filters) {
      root.querySelectorAll('.pr-filter').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('.pr-filter').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          applyFilter(btn.getAttribute('data-f'));
        });
      });
    }
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-readmore], .pr-readmore');
      if (rm && rm.hasAttribute('data-full')) {
        var card = rm.closest('.pr-card');
        var p = card && card.querySelector('.pr-card__msg');
        if (p) { p.innerHTML = rm.getAttribute('data-full'); p.classList.remove('is-clamped'); }
        rm.remove();
        return;
      }
      var ph = e.target.closest('.pr-photo');
      if (ph) openLightbox(ph.getAttribute('data-src'), 'Foto');
    });

    if (cfg.jsonld && cfg.productName && !previewing) {
      try {
        var ld = { '@context': 'https://schema.org', '@type': 'Product', name: cfg.productName };
        if (cfg.productUrl) ld.url = cfg.productUrl;
        ld.aggregateRating = { '@type': 'AggregateRating', ratingValue: round1(s.average), reviewCount: s.count, bestRating: 5, worstRating: 1 };
        ld.review = reviews.slice(0, 12).map(function (r) {
          var o = { '@type': 'Review', author: { '@type': 'Person', name: r.nombre || 'Cliente' }, reviewRating: { '@type': 'Rating', ratingValue: r.rating, bestRating: 5, worstRating: 1 } };
          if (r.mensaje) o.reviewBody = r.mensaje;
          if (r.fecha) o.datePublished = r.fecha;
          return o;
        });
        var sc = document.createElement('script');
        sc.type = 'application/ld+json';
        sc.textContent = JSON.stringify(ld);
        root.appendChild(sc);
      } catch (e) {}
    }
  }

  /* ---- modo marca (home) ---- */
  function renderBrand(root, data, cfg) {
    var reviews = (data && data.reviews) || [];
    if (!reviews.length) {
      if (cfg.emptyHide) { hideSection(root); return; }
      root.innerHTML = '<p class="pr-empty">Pronto, testimonios de la comunidad.</p>';
      return;
    }
    var s = (data && data.summary) || { count: reviews.length, average: 0 };
    var spotMin = cfg.spotMin;
    var featured = reviews.filter(function (r) { return r.tipo === 'cafeteria' || String(r.mensaje || '').length >= spotMin; });
    if (!featured.length) featured = [reviews.slice().sort(function (a, b) { return String(b.mensaje || '').length - String(a.mensaje || '').length; })[0]];
    var rest = reviews.filter(function (r) { return featured.indexOf(r) === -1; });
    // Si el mosaico quedaría con muy pocas tarjetas, mándalas todas al destacado
    // (evita la tarjeta suelta). El mosaico aparece cuando hay suficientes para llenarlo.
    if (rest.length < 3) { featured = reviews.slice(); rest = []; }

    var sumHTML = cfg.showSummary
      ? '<div class="pr-bsum">' + starsHTML(pctFrom(s.average)) + '<b>' + round1(s.average) + '</b><span>· ' + s.count + ' opinión' + (s.count === 1 ? '' : 'es') + '</span></div>'
      : '';

    var spotHTML = '<div class="pr-spot" data-pr-spot>';
    featured.forEach(function (r, idx) {
      var ct = clampText(r.mensaje, cfg.spotClamp);
      var more = ct.more ? '<button type="button" class="pr-spot__more" data-review="' + idx + '">Leer reseña</button>' : '';
      spotHTML += '<figure class="pr-spot__item' + (idx === 0 ? ' is-active' : '') + '">' +
          starsHTML(pctFrom(r.rating)) +
          '<blockquote class="pr-spot__q">' + (ct.more ? ct.clip : ct.html) + '</blockquote>' +
          more +
          '<figcaption class="pr-spot__by">' + avatarHTML(r) + whoHTML(r) + '</figcaption>' +
        '</figure>';
    });
    spotHTML += '</div>';

    var gridHTML = '';
    if (rest.length) {
      gridHTML = '<div class="pr-grid">';
      rest.forEach(function (r) {
        var ct = clampText(r.mensaje, cfg.clamp);
        var q = ct.more
          ? ct.clip + ' <button type="button" class="pr-readmore" data-full="' + ct.full + '">leer más</button>'
          : ct.html;
        gridHTML += '<article class="pr-gcard">' +
            starsHTML(pctFrom(r.rating)) +
            '<p class="pr-gcard__q' + (ct.more ? ' is-clamped' : '') + '">' + q + '</p>' +
            '<div class="pr-gcard__by">' + avatarHTML(r) + whoHTML(r) + '</div>' +
          '</article>';
      });
      gridHTML += '</div>';
    }

    root.innerHTML = sumHTML + spotHTML + gridHTML;

    var items = root.querySelectorAll('.pr-spot__item');
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (cfg.speed || 7) * 1000);
    }
    root.addEventListener('click', function (e) {
      var sm = e.target.closest('.pr-spot__more');
      if (sm) { openReviewModal(featured[parseInt(sm.getAttribute('data-review'), 10)]); return; }
      var rm = e.target.closest('.pr-readmore');
      if (rm && rm.hasAttribute('data-full')) {
        var p = rm.closest('.pr-gcard__q');
        if (p) { p.innerHTML = rm.getAttribute('data-full'); p.classList.remove('is-clamped'); }
      }
    });
  }

  /* ---- modo badge ---- */
  function renderBadge(root, data) {
    var s = (data && data.summary) || null;
    if (!s || !s.count) { root.style.display = 'none'; return; }
    root.innerHTML = '<a class="pr-badge" href="#pita-resenas">' + starsHTML(pctFrom(s.average)) +
      '<b>' + round1(s.average) + '</b><span>(' + s.count + ')</span></a>';
  }

  function readCfg(root) {
    return {
      filters: root.getAttribute('data-filters') !== 'false',
      jsonld: root.getAttribute('data-jsonld') !== 'false',
      showSummary: root.getAttribute('data-summary') !== 'false',
      pageSize: parseInt(root.getAttribute('data-pagesize'), 10) || 6,
      clamp: parseInt(root.getAttribute('data-clamp'), 10) || 300,
      emptyHide: root.getAttribute('data-empty-hide') === 'true',
      preview: root.getAttribute('data-preview') === 'true',
      productName: root.getAttribute('data-name') || '',
      productUrl: root.getAttribute('data-url') || '',
      spotMin: parseInt(root.getAttribute('data-spot-min'), 10) || 160,
      spotClamp: parseInt(root.getAttribute('data-spot-clamp'), 10) || 280,
      speed: parseInt(root.getAttribute('data-speed'), 10) || 7
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pita][data-pita-mode]').forEach(function (root) {
      if (root.dataset.prInit === '1') return;
      root.dataset.prInit = '1';
      var ep = root.getAttribute('data-endpoint') || DEFAULT_EP;
      var mode = root.getAttribute('data-pita-mode');
      var params = mode === 'brand'
        ? { scope: 'brand', limit: parseInt(root.getAttribute('data-limit'), 10) || 40 }
        : { handle: root.getAttribute('data-handle') || '', limit: parseInt(root.getAttribute('data-limit'), 10) || 60 };
      getReviews(ep, params).then(function (data) {
        if (mode === 'badge') return renderBadge(root, data);
        if (mode === 'brand') return renderBrand(root, data, readCfg(root));
        return renderProduct(root, data, readCfg(root));
      });
    });
  }

  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
